/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jul 26 2023
 **/

import React, { useState } from "react";

export default function useDragAndDrop<T = HTMLElement>(events?: { onDrop?: (e: React.DragEvent<T>) => void }) {
	const [isDragging, setIsDragging] = useState(false);

	const handleDragOver = (e: React.DragEvent<T>) => {
		e.preventDefault();
		setIsDragging(true);
	};

	const handleDragEnter = (e: React.DragEvent<T>) => {
		e.preventDefault();
		setIsDragging(true);
	};

	const handleDragLeave = () => {
		setIsDragging(false);
	};
	const handleDrop = (e: React.DragEvent<T>) => {
		e.preventDefault();
		events?.onDrop && events.onDrop(e);
		setIsDragging(false);
	};

	return {
		listeners: {
			onDragEnter: handleDragEnter,
			onDragLeave: handleDragLeave,
			onDragOver: handleDragOver,
			onDrop: handleDrop
		},
		isDragging
	};
}
